import React from 'react';
import env from 'env';
import utils from 'utils';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export function ImageSelector({ form, fieldName, data }) {

  const field = form.findControl(fieldName);
  //console.log(field, fieldName)

  React.useLayoutEffect(() => {
    const handleMessage = (e) => {
      console.log(e);
      var action = e.data.action;
      var onSelection = e.data.onSelection;
      var data = e.data.data;

      if (action === 'media-selected') {
        if (onSelection === 'selectedMediaFiles') {
          selectedMediaFiles(data);
        }
      }
    }
    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
    // eslint-disable-next-line
  }, [])

  function openLibrary(e) {
    var url = env.cmsEndpoint + '/cms41helper/browse/selectmedia?onSelection=selectedMediaFiles&maxSelect=1';
    var w = window.innerWidth;
    var h = window.innerHeight;
    window.open(url, 'cms_library', `toolbar=yes,scrollbars=yes,resizable=yes,top=${w * 0.05},left=${h * 0.05},width=${w * 0.9},height=${h * 0.9}`);

  }

  function selectedMediaFiles(items) {
    //const field = form.findControl(fieldName);
    if (!field) {
      console.error('cannot find the fieldname', fieldName)
      return;
    }

    //console.log(items)
    let obj = items;

    field.value = field.value || [];
    for (var i in obj.items) {
      field.value.push({ imageUrl: obj.items[i].WebPath, alt: obj.items[i].Alt});
    }
    form.reset()
  }

  function remove(e, index) {
    //if (!window.confirm('Delete this??')) return;
    field.value = utils.array.removeItem(field.value || [], index);
    form.reset()
  }

  function onDragEnd(result) {
    //console.log(result)
    //const field = form.findControl(fieldName);
    if (!field) return;

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    field.value = utils.array.moveItem(
      field.value || [],
      result.source.index,
      result.destination.index
    );

    form.reset()
  }

  return (
    <div className="imageSelector">

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`imageSelector__list ${snapshot.isDraggingOver ? 'imageSelector__list--dragging' : ''}`}
            // style={getListStyle(snapshot.isDraggingOver)}
            >
              {(field.value || []).map((item, index) => (
                <Draggable key={index} draggableId={index.toString()} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={provided.draggableProps.style}
                      className={`imageSelector__item ${snapshot.isDragging ? 'imageSelector__item--dragging' : ''}`}
                    >
                      <ImageListItem image={item} index={index}
                        onRemove={remove} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <button type="button" className="btn btn-warning btn-sm" onClick={(e) => openLibrary(e)}>Open Media Library</button>
    </div>
  );
}

function ImageListItem({ image, index, onRemove, onPackageChanged, onAUChanged, onNZChanged }) {
  return (
    <>
      <div className="">
        <img src={utils.site.resourcePath(image.imageUrl)} alt={image.alt} />
      </div>
      <div className="">

        <div className="remove">
          <button type="button" className="btn btn-secondary btn-sm"
            onClick={(e) => onRemove(e, index)}>Remove</button>

        </div>
      </div>
    </>
  )
}
